import {
  DEFAULT_ENVIRONMENT,
  DEFAULT_HISTORICAL_QUERY,
  DEFAULT_IMPERSONATE,
  EnvironmentData,
  HistoricalQueryData,
  ImpersonateData,
} from '../session';

export type CookieData = {
  version: 1;
  impersonate: ImpersonateData;
  environment: EnvironmentData;
  historicalQuery: HistoricalQueryData;
};
export const DEFAULT_COOKIE: CookieData = {
  version: 1,
  impersonate: DEFAULT_IMPERSONATE,
  environment: DEFAULT_ENVIRONMENT,
  historicalQuery: DEFAULT_HISTORICAL_QUERY,
};

export const COOKIE_KEY = 'io.density.app.cookie';
export const COOKIE_DOMAIN = window.location.host.startsWith('localhost:')
  ? 'localhost'
  : window.location.host.endsWith('.rodeo')
  ? '.density.rodeo'
  : '.density.io';

export function loadCookieData(): CookieData {
  try {
    const cookies = (document.cookie || '').split('; ');
    const densityCookieString = cookies.find((row) => row.startsWith(`${COOKIE_KEY}=`)) || '=';
    const encodedCookie = densityCookieString.split('=')[1] || JSON.stringify(DEFAULT_COOKIE);
    return JSON.parse(window.atob(encodedCookie)) || (DEFAULT_COOKIE as CookieData);
  } catch {
    return DEFAULT_COOKIE;
  }
}

export function saveCookieData(cookie: CookieData): void {
  const encodedCookie = window.btoa(JSON.stringify(cookie));
  document.cookie = `${COOKIE_KEY}=${encodedCookie}; domain=${COOKIE_DOMAIN}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT; SameSite=Strict`;
}
